<template>
    <div class="jgz-load" v-show="loadingShow">
        <div class="jgz-load-img"></div>
    </div>
</template>

<script>
export default {
    name: 'JgzLoading',
    props: {
        loadingShow: {default: false}
    }
}
</script>

<style lang='less'>
.jgz-load {
    background: rgba(0, 0, 0, .3);
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 99999;
    .jgz-load-img {
        height: 80px;
        width: 80px;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-40px, -40px);
        background-position: center;
        background-repeat: no-repeat;
        background-size: 100%;
        animation: jgzLoad 3s steps(1,end) infinite;
    }
}
@keyframes jgzLoad {
    0% {
        background-image: url('../assets/LoadImg/0.png')
    }
    2% {
        background-image: url('../assets/LoadImg/1.png')
    }
    4% {
        background-image: url('../assets/LoadImg/2.png')
    }
    6% {
        background-image: url('../assets/LoadImg/3.png')
    }
    8% {
        background-image: url('../assets/LoadImg/4.png')
    }
    10% {
        background-image: url('../assets/LoadImg/5.png')
    }
    12% {
        background-image: url('../assets/LoadImg/6.png')
    }
    14% {
        background-image: url('../assets/LoadImg/7.png')
    }
    16% {
        background-image: url('../assets/LoadImg/8.png')
    }
    18% {
        background-image: url('../assets/LoadImg/9.png')
    }
    20% {
        background-image: url('../assets/LoadImg/10.png')
    }
    22% {
        background-image: url('../assets/LoadImg/11.png')
    }
    24% {
        background-image: url('../assets/LoadImg/12.png')
    }
    26% {
        background-image: url('../assets/LoadImg/13.png')
    }
    28% {
        background-image: url('../assets/LoadImg/14.png')
    }
    30% {
        background-image: url('../assets/LoadImg/15.png')
    }
    32% {
        background-image: url('../assets/LoadImg/16.png')
    }
    34% {
        background-image: url('../assets/LoadImg/17.png')
    }
    36% {
        background-image: url('../assets/LoadImg/18.png')
    }
    38% {
        background-image: url('../assets/LoadImg/19.png')
    }
    40% {
        background-image: url('../assets/LoadImg/20.png')
    }
    42% {
        background-image: url('../assets/LoadImg/21.png')
    }
    44% {
        background-image: url('../assets/LoadImg/22.png')
    }
    46% {
        background-image: url('../assets/LoadImg/23.png')
    }
    48% {
        background-image: url('../assets/LoadImg/24.png')
    }
    50% {
        background-image: url('../assets/LoadImg/25.png')
    }
    52% {
        background-image: url('../assets/LoadImg/26.png')
    }
    54% {
        background-image: url('../assets/LoadImg/27.png')
    }
    56% {
        background-image: url('../assets/LoadImg/28.png')
    }
    58% {
        background-image: url('../assets/LoadImg/29.png')
    }
    60% {
        background-image: url('../assets/LoadImg/30.png')
    }
    62% {
        background-image: url('../assets/LoadImg/31.png')
    }
    64% {
        background-image: url('../assets/LoadImg/32.png')
    }
    66% {
        background-image: url('../assets/LoadImg/33.png')
    }
    68% {
        background-image: url('../assets/LoadImg/34.png')
    }
    70% {
        background-image: url('../assets/LoadImg/35.png')
    }
    72% {
        background-image: url('../assets/LoadImg/36.png')
    }
    74% {
        background-image: url('../assets/LoadImg/37.png')
    }
    76% {
        background-image: url('../assets/LoadImg/38.png')
    }
    78% {
        background-image: url('../assets/LoadImg/39.png')
    }
    80% {
        background-image: url('../assets/LoadImg/40.png')
    }
    82% {
        background-image: url('../assets/LoadImg/41.png')
    }
    84% {
        background-image: url('../assets/LoadImg/42.png')
    }
    86% {
        background-image: url('../assets/LoadImg/43.png')
    }
    88% {
        background-image: url('../assets/LoadImg/44.png')
    }
    90% {
        background-image: url('../assets/LoadImg/45.png')
    }
    92% {
        background-image: url('../assets/LoadImg/46.png')
    }
    94% {
        background-image: url('../assets/LoadImg/47.png')
    }
    96% {
        background-image: url('../assets/LoadImg/48.png')
    }
    98% {
        background-image: url('../assets/LoadImg/49.png')
    }
    100% {
    }
}
</style>
